import { handleActions } from 'redux-actions';
import { State } from './model';


const Reducer = handleActions({
  // common
  'appointmentCustodian/PUT_REQUEST': (state, { payload }) => {
    return state.setIn(['isPutting'], true)
                .setIn(['errMsg'], null);
  },
  'appointmentCustodian/PUT_SUCCESS': (state, { payload }) => {
    return state.setIn(['isPutting'], false)
                .setIn(['errMsg'], null);
  },
  'appointmentCustodian/PUT_FAILURE': (state, { payload }) => {
    return state.setIn(['isPutting'], false)
                .setIn(['errMsg'], payload.errMsg);
  },
}, State);

export default Reducer;